import { api } from '../lib/api'
import type { Kpi } from '../lib/types'

export const kpisApi = {
  list: () => api.get<{ kpis: Kpi[] }>('/kpis'),
}
